import {
    type NativeSelectFocusVisibleConstantType,
    type NativeSelectSectionsConstantType,
    type NativeSelectSection
} from "./type";

export const getNativeSelectSections = ({
    data
}: NativeSelectSectionsConstantType): Array<NativeSelectSection> => {
    const sections: Array<NativeSelectSection> = [];

    data.forEach((item) => {
        const lastSection = sections[sections.length - 1];

        const currentSection = item.group ? sections.find((section) => section.group === item.group) : lastSection?.group === undefined ? lastSection : undefined;

        if(currentSection) {
            currentSection.items.push(item);

            return;
        }

        sections.push({
            group: item.group,
            items: [
                item
            ]
        });
    });

    return sections;
};

export const getNativeSelectIsFocusVisible = ({
    element
}: NativeSelectFocusVisibleConstantType): boolean => {
    try {
        return element.matches(":focus-visible");
    } catch {
        return true;
    }
};
